import AdminModule from './admin';
import UserModule from './user';

export default [
  AdminModule,
  UserModule
];

